import React from 'react';
import { s } from '../styles';
import { BulletCard } from '../atoms';
import { IconPerson, IconSqueeze, IconSpark } from '../icons';

// Screen 0 — Intro. Three high-level bullets framing what the lesson
// is about before any anatomy or technique copy. The expectation chip
// just below the title settles "how long is this?" up front so the
// reader can decide whether to start now or save it for later.
export function Content({ t }) {
  return (
    <div className="screen-enter">
      <h1 style={s.title} className="screen-enter-child">{t('fl_intro_title')}</h1>
      <div
        className="screen-enter-child"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 12px',
          borderRadius: 999,
          background: 'color-mix(in srgb, var(--gold, #A8003F) 8%, transparent)',
          color: 'var(--gold, #A8003F)',
          fontFamily: "var(--font-ui, 'DM Sans', system-ui, sans-serif)",
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: '0.02em',
          marginBottom: 16,
        }}
      >
        <span aria-hidden="true">{'⋅'}</span>
        <span>{t('fl_intro_expectation')}</span>
      </div>
      <div style={s.bulletStack} className="screen-enter-child">
        <BulletCard icon={<IconPerson />} className="stagger-item" style={{ '--stagger-i': 0 }}>
          {t('fl_intro_bullet_1')}
        </BulletCard>
        <BulletCard icon={<IconSqueeze />} className="stagger-item" style={{ '--stagger-i': 1 }}>
          {t('fl_intro_bullet_2')}
        </BulletCard>
        <BulletCard icon={<IconSpark />} className="stagger-item" style={{ '--stagger-i': 2 }}>
          {t('fl_intro_bullet_3')}
        </BulletCard>
      </div>
    </div>
  );
}

export function Footer({ t, onNext }) {
  return (
    <button type="button" style={{ ...s.cta, ...s.ctaEnabled }} onClick={onNext}>
      {t('fl_intro_cta')}
    </button>
  );
}
